import { render, staticRenderFns } from "./Modul.vue?vue&type=template&id=928f7ee0&"
import script from "./Modul.vue?vue&type=script&lang=js&"
export * from "./Modul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports